<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ sysText.changeUsernameDialog_title | titlecase }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      [mat-dialog-close]
      [aria-label]="sysText.cancel"
      [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content [formGroup]="form">
  <p class="subtitle1 bottom-margin">
    {{ sysText.changeUsernameDialog_subtitle }}
  </p>
  <mat-form-field color="accent">
    <mat-label>{{ sysText.password | titlecase }}</mat-label>
    <input
      matInput
      [type]="hidePassword ? 'password' : 'text'"
      formControlName="password"
      autocomplete="current-password"/>
      <!-- mat hint for spacing -->
      <mat-hint></mat-hint>
      <mat-error>{{ password.errors?.required ? (sysText.required | capitalizefirst) : password.errors?.msError }}</mat-error>
      <button type="button" class="button-reset" matSuffix [attr.aria-label]="sysText.showPassword_ariaLabel" [attr.aria-pressed]="!hidePassword" (click)="hidePassword = !hidePassword">
        <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field color="accent">
      <mat-label>{{ sysText.newUsername | titlecase }}</mat-label>
      <input
        matInput
        type="text"
        formControlName="username"
        autocomplete="username"/>
      <mat-error>{{ username.errors?.required ? (sysText.required | capitalizefirst) : username.errors?.msError }}</mat-error>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @let isSubmitting = isSubmitting$ | async;
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        type="button"
        [mat-dialog-close]
        color="accent"
        [disabled]="isSubmitting">
        {{ sysText.cancel }}
      </button>
    }
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      type="submit"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && changeUsername()">
      {{ sysText.changeUsername }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </mat-dialog-actions>
